module.exports = __webpack_public_path__ + "static/img/coe-4ton-white.68314e8.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/coe-4ton-white.svg
// module id = EFRX
// module chunks = 82